module.exports = __webpack_public_path__ + "static/media/muscle_front_6.9c6686e3.png";